import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/** Legacy /messages/:conversationId → unified inbox */
const ConversationDeepLink = () => {
  const { conversationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/conversations', {
      replace: true,
      state: { conversationId },
    });
  }, [conversationId, navigate]);

  return null;
};

export default ConversationDeepLink;
